import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './Dashboard.css';
import Chart from 'chart.js/auto';
import { Card, CardBody, CardHeader, CardText, CardTitle, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import BaseUrl from '../../base-api';
import axios from 'axios';

const Dashboard = () => {
  const chartRef = useRef(null);
  const navigate = useNavigate(); // Initialize navigate

  const [data, setData] = useState([]);
  const [statusCounts, setStatusCounts] = useState({
    totalCandidates: 0,
    verifiedCandidates: 0,
    notVerifiedCandidates: 0,
    pendingFullCourseFee: 0,
    registeredCourseFeePending: 0
  });
  const [courseData, setCourseData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/admin/adminDashboard`, {
          headers: {
            Authorization: localStorage.getItem("$3ingT0k3n"),
          },
        });
        setData(response.data.data);
        setCourseData(response.data.courseDto);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  useEffect(() => {
    const ctx = document.getElementById('acquisitions').getContext('2d');

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    const chartData = {
      labels: courseData.map(course => course.name),
      datasets: [
        {
          label: 'Courses Count',
          data: courseData.map(course => course.count),
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(201, 203, 207, 0.2)',
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)',
          ],
          borderWidth: 1,
        },
      ],
    };

    chartRef.current = new Chart(ctx, {
      type: 'bar',
      data: chartData,
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              title: (tooltipItems) => tooltipItems[0]?.label || '',
              label: (tooltipItem) => `${tooltipItem.label}: ${tooltipItem.raw}`,
            },
            position: 'nearest',
            external: (tooltipModel) => {
              let tooltipEl = document.getElementById('chartjs-tooltip');

              if (!tooltipEl) {
                const newTooltipEl = document.createElement('div');
                newTooltipEl.id = 'chartjs-tooltip';
                newTooltipEl.style.opacity = '0';
                newTooltipEl.style.position = 'absolute';
                newTooltipEl.style.backgroundColor = 'white';
                newTooltipEl.style.border = '1px solid rgba(0, 0, 0, 0.1)';
                newTooltipEl.style.borderRadius = '3px';
                newTooltipEl.style.padding = '10px';
                newTooltipEl.style.pointerEvents = 'none';
                newTooltipEl.style.zIndex = '1000';
                document.body.appendChild(newTooltipEl);
                tooltipEl = document.getElementById('chartjs-tooltip');
              }

              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = '0';
                return;
              }

              tooltipEl.style.opacity = '1';
              tooltipEl.style.left = `${tooltipModel.caretX - tooltipEl.offsetWidth / 2}px`;
              tooltipEl.style.top = `${tooltipModel.caretY - tooltipEl.offsetHeight - 10}px`;

              tooltipEl.innerHTML = tooltipModel.body ? tooltipModel.body.map(item => item.lines).join('<br>') : '';
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, [courseData]);

  const { totalCandidates, verifiedCandidates, notVerifiedCandidates, pendingFullCourseFee, registeredCourseFeePending } = statusCounts;


  const handleCardClick = (status, title) => {
    navigate('/SideBar/registered-application', { state: { status: status, title: title } });
  };

  return (
    <>
      <div className="py-2 border round mt-1" style={{ margin: '0 2%', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', borderRadius: '9px' }}>
        <h4 className='text-center mt-2'>Dashboard</h4>
        <div style={{ margin: '1% 1%' }}>
          <Row className="text-center">
            {data.map((element, index) => (
              <Col md={4} className='mt-2'>
                <Card className='p-1 m-2'
                  onClick={() => element.count > 0 ? handleCardClick(element.type, element.title) : ""}
                  style={{ backgroundColor: '#6a73fa', border: "1px white", cursor: 'pointer', minHeight: '120px', maxHeight: '70px' }}
                >
                  <CardBody style={{ color: 'white' }}>
                    <CardText style={{ fontSize: "1.8em" }}>{loading ? 'Loading...' : element.count}</CardText>
                    <CardTitle tag="h6">{element.title}</CardTitle>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

        </div>

        <div className="py-2 mt-3" style={{ width: "98%" }}>
          <canvas id="acquisitions"></canvas>
        </div>
      </div >
    </>
  );
};

Dashboard.propTypes = {};

Dashboard.defaultProps = {};

export default Dashboard;
